"use client";

/** The small "New" marker beside a menu label (What's new): a neutral
 *  grey tag (quiet UI, 2026-10-29), shown for at most NEW_MARK_DAYS. */
import { useT } from "@/lib/locale-context";
import { TAG } from "@/lib/ui-classes";

export default function NewPill({ onSolid = false }: { onSolid?: boolean }) {
  const t = useT();
  return (
    <span
      className={`shrink-0 rounded px-1 py-0.5 text-[10px] font-bold leading-none ${
        onSolid ? "bg-gray-200 text-gray-700" : TAG
      }`}
    >
      {t("wn.new")}
    </span>
  );
}
